import { render } from "./AudienceCompanyView.vue?vue&type=template&id=503b4c7e"
import script from "./AudienceCompanyView.vue?vue&type=script&lang=js"
export * from "./AudienceCompanyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__